import {
  closeCloseTimeModal,
  closeEstimateModal,
  closeImagesModal,
  closeLotDetailsModal,
  closeLotModal,
  closeImageViewer,
  nextImage,
  previousImage,
} from '../modules/ui';
import {
  isCloseTimeModalOpen,
  isEstimateModalOpen,
  isImagesModalOpen,
  isLotDetailsModalOpen,
  isModalOpen,
  isImageViewerOpen,
} from '../modules/ui/modals';

export function setupKeyboardHandlers(): void {
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (isImageViewerOpen()) {
        event.preventDefault();
        closeImageViewer();
      } else if (isCloseTimeModalOpen()) {
        event.preventDefault();
        closeCloseTimeModal();
      } else if (isEstimateModalOpen()) {
        event.preventDefault();
        closeEstimateModal();
      } else if (isLotDetailsModalOpen()) {
        event.preventDefault();
        closeLotDetailsModal();
      } else if (isImagesModalOpen()) {
        event.preventDefault();
        closeImagesModal();
      } else if (isModalOpen()) {
        event.preventDefault();
        closeLotModal({ reset: true });
      }
    } else if (isImageViewerOpen()) {
      // Arrow key navigation for fullscreen image viewer
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        previousImage();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        nextImage();
      }
    }
  });
}
